import React from 'react'
import yoga from "../../assets/images/onboarding/yoga.jpg";
import { Link } from 'react-router-dom';
import { t } from 'i18next';

const LowBalance = () => {
  return (
    <div className="inprogress">
    <div className="subsWrapper2">
      <div className="successBox">
        <img src={yoga} alt="wellness" className="img-fluid" style={{ width: "100%" }} />
      </div>
      <div className="subsWrapper">
        <div className="successCont">
          <div className='lowbalanceWrap'>
            <div className='lowImg'>
                <img src={require('../../assets/images/layout/lowbalance.png')} className='img-fluid' alt="" />
            </div>
            <div className='lowText'>
                <h2>{t("lowbalance.title")}</h2>
                <p>{t("lowbalance.content")}</p>
                <Link to="/">{t("lowbalance.btn")}</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default LowBalance
